import React from 'react'

interface TranslationScopeSectionProps {
  sourceLanguage: string
  languageControl: React.ReactNode
  targetHelper?: React.ReactNode
  versionControl?: React.ReactNode
}

const TranslationScopeSection: React.FC<TranslationScopeSectionProps> = ({
  sourceLanguage,
  languageControl,
  targetHelper,
  versionControl,
}) => (
  <section className="translation-modal-block translation-modal-block--scope" aria-labelledby="translation-scope-heading">
    <div className="translation-modal-block-header">
      <div>
        <h3 id="translation-scope-heading">Translation scope</h3>
        <p>
          Translating from <strong>{sourceLanguage || 'the source language'}</strong>. Choose the target language
          {versionControl ? ' and source text' : ''}.
        </p>
      </div>
    </div>
    <div className="translation-scope-route-row">
      <div className={`translation-scope-field${versionControl ? '' : ' translation-scope-field--readonly'}`}>
        {versionControl || (
          <>
            <span className="translation-modal-kicker">Source language</span>
            <strong>{sourceLanguage || 'Not selected'}</strong>
          </>
        )}
      </div>
      <div className="translation-scope-route-divider" aria-hidden="true">
        to
      </div>
      <div className="translation-scope-field">
        {languageControl}
        {targetHelper ? <div className="translation-scope-field-helper">{targetHelper}</div> : null}
      </div>
    </div>
  </section>
)

export default TranslationScopeSection
